'use client';

import breakpoints from '@carvana/merch-tailwind/breakpoints';
import { appAssetsCdnUrl } from '~/constants/environment';
import GeolocationButton from './GeolocationButton';
import { GoldText } from './Hero.styles';

export default function NewCarsHero() {
  const heroBackgroundDesktopSrc = `${appAssetsCdnUrl}/images/new-car/hero-new-desktop.svg`;
  const heroBackgroundMobileSrc = `${appAssetsCdnUrl}/images/new-car/hero-new-mobile.svg`;

  return (
    <section
      className="relative h-[199px] overflow-hidden bg-background-weak md:h-[288px]"
      data-testid="hero"
    >
      <picture aria-hidden="true">
        <source
          media={`(min-width: ${breakpoints.md}px)`}
          srcSet={heroBackgroundDesktopSrc}
        />
        <img
          alt=""
          className="absolute inset-0 size-full object-cover object-[center_bottom]"
          src={heroBackgroundMobileSrc}
        />
      </picture>
      <div className="relative z-10 flex h-full flex-col items-center justify-center gap-xl px-2xl">
        <h1 className="text-center text-text-inverse t-brand-sm md:t-brand-lg">
          DISCOVER{' '}
          <GoldText className="t-brand-sm md:t-brand-lg">NEW CARS</GoldText>
          <br />
          AT CARVANA
        </h1>
        <GeolocationButton />
      </div>
    </section>
  );
}
